export default {
  // 回显数据
  selectOptionLabel(datas, value) {
    var actions = []
    Object.keys(datas).some((key) => {
      if (datas[key].id == '' + value) {
        actions.push(datas[key].name)
        return true
      }
    })
    return actions.join('')
  },
  selectOptionLabels(datas, value, separator) {
    var actions = []
    var currentSeparator = undefined === separator ? ',' : separator
    if (!value) return ''
    var temp = value.split(currentSeparator)
    Object.keys(value.split(currentSeparator)).some((val) => {
      Object.keys(datas).some((key) => {
        if (datas[key].id == '' + temp[val]) {
          actions.push(datas[key].name + currentSeparator)
        }
      })
    })
    return actions.join('').substring(0, actions.join('').length - 1)
  },
  // 日期格式化
  parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
      return ''
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      } else if (typeof time === 'string') {
        time = time.replace(new RegExp(/-/gm), '/')
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay(),
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },
  // 格式化时间
  formatTimeReduceT(str) {
    if (!str) {
      return ''
    } else {
      return str.split('T').join(' ')
    }
  },
 
}
